import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import FilterResetButton from './FilterResetButton'
import MultiSelectFilter from './MultiSelectFilter'

const filterComponents = {
  list_multiselect: MultiSelectFilter,
}

function FilterBar({
  className,
  aggregations = {},
  submitForms,
  resetAllFilters,
  numberOfActiveFilters = 0,
  searchData,
  categoryUrls,
}) {
  const wrapperClass = classNames(
    'product-grid__filter-bar-form filter-bar d-flex flex-row flex-wrap',
    className
  )

  return (
    <form
      id="product-list-filter-form"
      className={wrapperClass}
      style={{ gap: '0.5rem' }}
    >
      {Object.values(aggregations)
        .sort((a, b) => a.position - b.position)
        .map(({ key, type, ...rest }) => {
          const Component = filterComponents[type]
          if (!Component) {
            return null
          }
          return (
            <Component
              key={key}
              fieldId={key}
              submitForms={submitForms}
              searchData={searchData}
              categoryUrls={categoryUrls}
              {...rest}
            />
          )
        })}
      {numberOfActiveFilters > 0 && (
        <FilterResetButton resetAllFilters={resetAllFilters} />
      )}
    </form>
  )
}

FilterBar.propTypes = {
  className: PropTypes.string,
  aggregations: PropTypes.object,
  submitForms: PropTypes.func.isRequired,
  resetAllFilters: PropTypes.func.isRequired,
  numberOfActiveFilters: PropTypes.number,
  searchData: PropTypes.any,
  categoryUrls: PropTypes.any,
}

export default FilterBar
